import { action, observable } from "mobx";
import Validation, { ValidationTypes } from "../utils/Validation";

class Immersive3dTourPanorama extends Validation {
  @observable id;

  @observable upload;

  @observable url;

  @observable size;

  @observable metadata;

  @observable isSelected;

  constructor(data) {
    super();
    this.setData(data);
    this.validates();
  }

  internalValidates() {
    const { exifReadable, equirectangular, dateTimeOriginal, width } = this.metadata;

    if (!exifReadable) {
      this.addValidationMessage(
        `Image ${this.upload.name} is missing EXIF data, or it could not be read.`,
        ValidationTypes.ERROR,
      );
    }

    if (!equirectangular) {
      this.addValidationMessage(
        `Image ${this.upload.name} does not seem to be equirectangular. Please check to make sure the image width is exactly 2 times the height.`,
        ValidationTypes.ERROR,
      );
    }

    if (width && width < 3000) {
      this.addValidationMessage(
        `Image ${this.upload.name} needs to be bigger than 3000 pixels in width.`,
        ValidationTypes.ERROR,
      );
    }

    if (!dateTimeOriginal) {
      this.addValidationMessage(
        `Image ${this.upload.name} is missing image original date & time. Sorting by date & time might not work as expected.`,
        ValidationTypes.INFO,
      );
    }
  }

  @action
  setData(data) {
    const { id, upload, url, size, metadata, isSelected = false } = data;
    this.id = id;
    this.upload = upload;
    this.url = url;
    this.size = size;
    this.metadata = metadata;
    this.isSelected = isSelected;
  }

  @action
  setIsSelected(isSelected) {
    this.isSelected = isSelected;
  }
}

export default Immersive3dTourPanorama;
